import { useAppSelector } from '@shared/store';
import { selectUserId } from '@entities/account';

export const useAccountUserId = () => {
  const userId = useAppSelector(selectUserId);

  return userId;
};
